import { Component, EventEmitter, Input, Output } from '@angular/core';

/**
 * Delete confirmation dialog, same markup and styling as the contact detail
 * view. Use with two-way binding on `opened`:
 *
 *   <app-delete-confirm-dialog
 *     [(opened)]="deletionDialogOpened"
 *     [message]="t('deletionMessage')"
 *     (confirmed)="deleteConfirmed()">
 *   </app-delete-confirm-dialog>
 *
 * `title` and `message` are optional; without them the generic texts of the
 * `deleteConfirmDialog` i18n scope are shown.
 */
@Component({
    selector: 'app-delete-confirm-dialog',
    templateUrl: './delete-confirm-dialog.component.html',
    standalone: false
})
export class DeleteConfirmDialogComponent {

  @Input() opened = false;
  @Output() openedChange = new EventEmitter<boolean>();

  @Input() title?: string;
  @Input() message?: string;

  @Output() confirmed = new EventEmitter<void>();
  @Output() cancelled = new EventEmitter<void>();

  close(status: 'cancel' | 'delete'): void {
    this.opened = false;
    this.openedChange.emit(false);

    if (status === 'delete') {
      this.confirmed.emit();
    } else {
      this.cancelled.emit();
    }
  }
}
